"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconPersonFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M5.57431 7.02311C4.97756 7.28048 4.38189 7.64203 3.83564 8.12759C2.47639 9.33581 1.5 11.2434 1.5 14C1.5 14.5523 1.94772 15 2.5 15L13.5 15C14.0523 15 14.5 14.5523 14.5 14C14.5 11.2434 13.5236 9.33581 12.1644 8.12759C11.6181 7.64203 11.0224 7.28048 10.4257 7.02311C11.0879 6.3863 11.5 5.49128 11.5 4.5C11.5 2.567 9.933 1 8 1C6.067 1 4.5 2.567 4.5 4.5C4.5 5.49128 4.91209 6.3863 5.57431 7.02311Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 1C7.51472 1 5.5 3.01472 5.5 5.5C5.5 6.74287 6.00386 7.86805 6.81846 8.68242C6.15924 8.97894 5.50044 9.39004 4.88823 9.94901C3.19501 11.495 2 14.0417 2 18C2 18.5523 2.44772 19 3 19H17C17.5523 19 18 18.5523 18 18C18 14.0417 16.805 11.495 15.1118 9.94901C14.4996 9.39004 13.8408 8.97894 13.1815 8.68242C13.9961 7.86805 14.5 6.74287 14.5 5.5C14.5 3.01472 12.4853 1 10 1Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 1C8.96243 1 6.5 3.46243 6.5 6.5C6.5 8.24675 7.31428 9.80331 8.58395 10.8108C7.80811 11.1828 7.02656 11.7025 6.3019 12.409C4.40065 14.2627 3 17.2945 3 22C3 22.5523 3.44772 23 4 23H20C20.5523 23 21 22.5523 21 22C21 17.2945 19.5993 14.2627 17.6981 12.409C16.9734 11.7025 16.1919 11.1828 15.416 10.8108C16.6857 9.80331 17.5 8.24675 17.5 6.5C17.5 3.46243 15.0376 1 12 1Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 2C12.134 2 8.99999 5.13401 8.99999 9C8.99999 10.9573 9.80334 12.727 11.0983 13.9973C9.96551 14.4691 8.82458 15.1361 7.76647 16.055C5.0064 18.4519 3 22.3972 3 28.5C3 29.3284 3.67157 30 4.5 30H27.5C28.3284 30 29 29.3284 29 28.5C29 22.3972 26.9936 18.4519 24.2335 16.055C23.1754 15.1361 22.0345 14.4691 20.9017 13.9973C22.1967 12.727 23 10.9573 23 9C23 5.13401 19.866 2 16 2Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;